import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { config } from './env';

/**
 * Firebase is used for authentication and nothing else. It is the same
 * project as slate-web, so an admin signs in with the account they already
 * have; whether that account may use this panel is the API's decision, made
 * against the admins table on every request.
 */

function app(): FirebaseApp {
  return getApps().length > 0 ? getApp() : initializeApp(config.firebase);
}

export const firebaseApp: FirebaseApp = app();
export const auth: Auth = getAuth(firebaseApp);
